var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-container white"},[_c('div',{staticClass:"event-list"},_vm._l((_vm.events),function(event){return _c('EventOverview',{key:event.id,attrs:{"event":event}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }